import { add } from "lodash";
import Vue from "vue";

export const Onduty = {
    methods: {
        async getonDuty(params,date) {
            let { pageNum, pageSize, name } = params

            let res = await this.$http.get("/tenant/arrange/month", {
                month:date?? new Date().getMonth() + 1,
                name: name ?? null,
                pageNum: pageNum ?? null,
                pageSize: pageSize ?? null
            });
            console.log(res);
            return res;
        },

        //TODO: 保存排班
        async saveOnDuty(obj) {
            let res = await this.$http.put(`/tenant/arrange/save`, obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO: 获取左侧的类型
        async getOnDutyType() {
            let res = await this.$http.get(`/tenant/arrange/type/list`);

            return res.data || []

        },
        //TODO: 新增值班类型
        async addOnDutyType(obj) {
            let res = await this.$http.post(`/tenant/arrange/type`, obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO: 修改值班类型
        async upOnDutyType(obj) {
            let res = await this.$http.put(`/tenant/arrange/type`, obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
         //TODO: 删除值班类型
         async delOnDutyType(obj) {
            let res = await this.$http.delete(`/tenant/arrange/type/${obj.id}`);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        },
        //TODO: 检查是否可以复制排班
        async checkCopy(obj) {
            let res = await this.$http.post(`/tenant/arrange/check`,obj);
          
            return res
        },
        //TODO: 复制排班
        async copyOnDuty(obj) {
            let res = await this.$http.post(`/tenant/arrange/copy`,obj);
            if (res.code == 200) {
                this.$message({ message: res.msg, type: "success" });
            } else {
                this.$message.error(res.msg);
            }
            return res;
        }
    },
};
